// Pure helpers for agent chat — extracted for testability.
// Used by AgentChatContext.jsx and AIChatPanel.jsx.

/**
 * Map a URL pathname to a context object for the AI chat.
 * Pure function — no React or Firebase dependencies.
 */
export function resolvePageContext(pathname) {
  const parts = pathname.split('/').filter(Boolean);

  if (parts[0] === 'leads' && parts[1]) {
    return { page: pathname, entityType: 'lead', entityId: parts[1] };
  }
  if (parts[0] === 'projects' && parts[1]) {
    return { page: pathname, entityType: 'project', entityId: parts[1] };
  }
  if (parts[0] === 'portfolio') {
    return { page: pathname, entityType: 'portfolio', entityId: null };
  }
  if (parts[0] === 'dashboard' || pathname === '/') {
    return { page: pathname, entityType: 'dashboard', entityId: null };
  }
  return { page: pathname, entityType: 'general', entityId: null };
}

/**
 * Page-aware placeholder text for the chat input.
 * Sets user expectations that the assistant is scoped to FlipperPro / real estate.
 */
export function getInputPlaceholder(pageContext) {
  switch (pageContext?.entityType) {
    case 'lead':
      return "Ask about this lead's comps, MAO, or rehab estimate...";
    case 'project':
      return "Ask about this project's budget, timeline, or expenses...";
    case 'portfolio':
      return 'Ask about your portfolio ROI, deals, or trends...';
    case 'dashboard':
      return 'Ask about your pipeline, hot leads, or deals...';
    default:
      return 'Ask about your real estate deals...';
  }
}

/**
 * Page-aware suggested prompts shown as clickable chips on first open.
 * 3-4 strings per entity type — clicking sends the prompt verbatim.
 * Centralized here so AIChatPanel stays presentational and copy is one place to edit.
 */
export function getSuggestedPrompts(pageContext) {
  switch (pageContext?.entityType) {
    case 'lead':
      return [
        'Run a flip analysis on this lead',
        "What's the MAO for this property?",
        'Pull comparable sales',
        'Estimate rehab cost',
      ];
    case 'project':
      return [
        "Show this project's budget",
        "What's left to spend?",
        'Estimate completion date',
      ];
    case 'portfolio':
      return [
        "What's my average ROI?",
        'Show my top 3 deals',
        'Compare flips vs rentals',
      ];
    case 'dashboard':
    case 'general':
    default:
      return [
        'Analyze my newest lead',
        'Show my pipeline',
        "What's a 70% rule MAO?",
      ];
  }
}
